import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput } from 'components';
import { FormattedMessage, injectIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(1),
  },
  addUserButton: {
    marginRight: theme.spacing(1),
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
}));

const UserssToolbar = props => {
  const { className, handleClickAdd, handleClickAssignOrganizations,enableAssignOrganizations, handleSearch, intl, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <Button className={classes.addUserButton} color="primary" variant="contained" onClick={handleClickAdd}>
          <FormattedMessage id="users.add" />
        </Button>
        <Button disabled={!enableAssignOrganizations} color="primary" variant="contained" onClick={handleClickAssignOrganizations}>
          <FormattedMessage id="users.assignOrganizations" />
        </Button>
        <span className={classes.spacer} />
        <SearchInput
          className={classes.searchInput}
          onChange={handleSearch}
          placeholder={intl.formatMessage({ id: 'users.search' })}
        />
      </div>
    </div>
  );
};

UserssToolbar.propTypes = {
  className: PropTypes.string,
  handleClickAdd: PropTypes.func.isRequired,
  handleClickAssignOrganizations: PropTypes.func.isRequired,
  enableAssignOrganizations: PropTypes.bool.isRequired,
  handleSearch: PropTypes.func.isRequired,
};

export default injectIntl(UserssToolbar);
